export const MARKETING_TYPE = {
  EMAIL: '이메일',
  SMS: '문자',
};
